/**
 https://xlm-web-test.suixingpay.com

 https://xlm-web.suixingpay.com
 */

export let dev = ''; // 环境：开发 dev; 生产 pro;
let envMap;
if (window.location.origin !== 'https://xlm-app-web.xlsuixing.com') {
  envMap = {
    XLM_WEB: 'https://xlm-web-test.suixingpay.com',
    OSS_PATH: 'https://xlmapp.oss-cn-beijing.aliyuncs.com/develop/', // oss地址
  };
} else {
  envMap = {
    XLM_WEB: 'https://xlm-web.xlsuixing.com',
    OSS_PATH: 'https://xlmapp.oss-cn-beijing.aliyuncs.com/production/',
  };
}

window.ossPath = envMap.OSS_PATH;

export const WEB_URL = {
  ALLY_EXAM: `${envMap.XLM_WEB}/examinationNotes/examination-newnotes`, // 考试
};

export const downloadAppUrl = 'https://xlm-web.xlsuixing.com/download/index.html';
